import { useQuery } from '@tanstack/react-query';
import { fetchUpcomingFestivals } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

/** Upcoming festivals, soonest first — the pinned Festivals section on the Events page. */
export function useUpcomingFestivals({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.events.festivals(),
    queryFn: fetchUpcomingFestivals,
    enabled,
    staleTime: STALE.semiStatic,
  });
}
